module.exports = __webpack_public_path__ + "static/media/files.ef128e26.svg";